import React from 'react';
import { FaLightbulb } from 'react-icons/fa';

export function TabStory({ icon: Icon, title, subtitle, art }) {
  return (
    <div className="finance-tab-story">
      <div className="finance-tab-story-main">
        <div className="finance-tab-story-icon">{Icon && <Icon />}</div>
        <div>
          <h2 className="finance-tab-story-title">{title}</h2>
          <p className="finance-tab-story-subtitle">{subtitle}</p>
        </div>
      </div>
      {art && <img src={art} alt="" className="finance-tab-story-art" aria-hidden="true" />}
    </div>
  );
}

export function FlowGuide({ title, steps }) {
  return (
    <div className="finance-flow-guide">
      {title && <h3 className="finance-flow-guide-title">{title}</h3>}
      <div className="finance-flow-guide-track">
        {steps.map((step, index) => (
          <React.Fragment key={step.label}>
            <div className="finance-flow-step">
              <div className="finance-flow-step-num">{index + 1}</div>
              <div className="finance-flow-step-icon">{step.icon && <step.icon />}</div>
              <strong>{step.label}</strong>
              <span>{step.desc}</span>
            </div>
            {index < steps.length - 1 && (
              <div className="finance-flow-arrow" aria-hidden="true">
                <span className="finance-flow-arrow-icon finance-flow-arrow-icon--h">→</span>
                <span className="finance-flow-arrow-icon finance-flow-arrow-icon--v">↓</span>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export function FormPanel({ icon: Icon, title, hint, children }) {
  return (
    <div className="finance-form-panel">
      <div className="finance-form-panel-head">
        <div className="finance-form-panel-icon">{Icon && <Icon />}</div>
        <div>
          <h3>{title}</h3>
          {hint && <p>{hint}</p>}
        </div>
      </div>
      {children}
    </div>
  );
}

export function HelpTip({ children }) {
  return (
    <div className="finance-help-tip">
      <FaLightbulb className="finance-help-tip-icon" aria-hidden="true" />
      <p>{children}</p>
    </div>
  );
}

export function ListPanel({ icon: Icon, title, count, children }) {
  return (
    <div className="finance-list-panel">
      <div className="finance-list-panel-head">
        <div className="finance-list-panel-icon">{Icon && <Icon />}</div>
        <div>
          <h3>{title}</h3>
          {count != null && (
            <span className="finance-list-panel-count">{count} {count === 1 ? 'entry' : 'entries'}</span>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}
